// Разбивает текст из админки на абзацы <p> (абзацы разделяются пустой строкой)
export const toParagraphs = (text) =>
    text
        ? text.split(/\n\s*\n/).map((paragraph, index) => <p key={index}>{paragraph}</p>)
        : null;
